module.exports = "/src/views/player/help/images/news2.jpg";